import { z } from "zod";
import { state } from "./mobileOrchestrator";

export const mobileReactivationOrchestrator = z.object({
  type: z.literal("NJU_MOBILE_REACTIVATION"),
  state,
  id: z.string(),
  products: z.object({
    id: z.string(),
    specificationId: z.literal("MOBILE_ACCESS"),
    vlocityOfferId: z.string(),
  }),
  orderSummary: z.object({
    totalOrderPrice: z.number(),
    totalRecurringOrderPrice: z.number(),
    totalOneTimeOrderPrice: z.number(),
    discount: z.number().optional(),
    totalOrderDiscount: z.number().optional(),
    totalRecurringOrderBasePrice: z.number().optional(),
    items: z.array(
      z.object({
        offerId: z.string(),
        offerPrice: z.number(),
        offerPriceType: z.string(),
      }),
    ),
  }),
});

export type IMobileReactivationOrchestratorApi = z.infer<
  typeof mobileReactivationOrchestrator
>;

export type IMobileReactivationOrchestrator =
  IMobileReactivationOrchestratorApi & {
    isFreeFromActivationFee?: boolean;
  };
